document.addEventListener('DOMContentLoaded', () => {
		const mobileMenu = document.querySelector('.mobile-menu');
		const burgerBtn = document.querySelector('.burger-btn');
		const navLinks = document.querySelectorAll('.menu a');
		const body = document.body;

		let scrollPosition = 0;

		burgerBtn.addEventListener('click', function() {
				this.classList.toggle('active');
				mobileMenu.classList.toggle('mobile-menu--active');

				if (mobileMenu.classList.contains('mobile-menu--active')) {
						scrollPosition = window.pageYOffset;
						body.style.cssText = `
								overflow: hidden;
								position: fixed;
								top: -${scrollPosition}px;
								width: 100%;
						`;
				} else {
						body.style.cssText = '';
						window.scrollTo(0, scrollPosition);
				}
		});

		navLinks.forEach(link => {
				link.addEventListener('click', function(e) {
						e.preventDefault();

						const targetId = this.getAttribute('href');

						if (targetId && !targetId.startsWith('#')) {
								// Якщо посилання не починається з #, переходимо за ним
								window.location.href = targetId;
						} else if (targetId && targetId !== '#') {
								// Якщо це якірне посилання з #
								const targetElement = document.querySelector(targetId);

								if (targetElement) {
										mobileMenu.classList.remove('mobile-menu--active');
										burgerBtn.classList.remove('active');
										body.style.cssText = '';
										window.scrollTo(0, scrollPosition);

										setTimeout(() => {
												targetElement.scrollIntoView({
														behavior: 'smooth',
														block: 'start'
												});
										}, 100);
								}
						}
				});
		});
});
